export default __webpack_public_path__ + "static/media/plain-sticker-cc.4e56f17c.png";